<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area" v-if="emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Employees</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/employees'" class="current">Employees</router-link>
                        </li>
                    </ul>
                </div>
                <div class="actions">
                    <button class="btn btn-primary" @click.prevent="createEmployee" v-show="showCreateEmployees">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.99984 4.16666V15.8333M4.1665 9.99999H15.8332" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Add Employees
                    </button>
                    <div class="dropdown">
                        <a class="btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"> More Actions </a>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <li><a class="dropdown-item" href="#" @click.prevent="getExport">Export Employee</a></li>
                            <li><a class="dropdown-item" href="#" @click.prevent="createEmployeeImport" v-show="showCreateEmployees">Import Employees</a></li>
                            <li><a class="dropdown-item" href="#" @click.prevent="getQrCode">Download QR Codes</a></li>
                            <li><a class="dropdown-item" href="#" @click.prevent="deleteBulk">Bulk Delete</a></li>
                            <li><a class="dropdown-item" href="#" @click.prevent="assignTags">Assign Tags</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div class="searchbar">
                    <form id="getFilterDataform" action="#">
                        <div class="internalSearchBar">
                            <input class="employeeSearchBar" type="text" name="search" v-model="filterForm.search_data" placeholder="Search for Employees" @keyup="applyFilter" />
                        </div>
                        <div class="filters">
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Type</span><span class="filter__value"></span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" @click="filterTypesCheckbox" data-id="static_qr">
                                        <input type="checkbox" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">QR</label>
                                    </div>
                                    <div class="input-checkbox" data-active="false" @click="filterTypesCheckbox" data-id="gps_checkin">
                                        <input type="checkbox" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Remote</label>
                                    </div>
                                    <div class="input-checkbox" data-active="false" @click="filterTypesCheckbox" data-id="qr_card">
                                        <input type="checkbox" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Kiosk</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Status</span><span class="filter__value"></span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" @click="filterStatusCheckbox" data-id="active">
                                        <input type="checkbox" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Active</label>
                                    </div>
                                    <div class="input-checkbox" data-active="false" @click="filterStatusCheckbox" data-id="in_active">
                                        <input type="checkbox" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Inactive</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Location</span><span class="filter__value"></span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="location in locations" @click="filterLocationsCheckbox" :data-id="location.id">
                                        <input type="checkbox" name="location_id[]" :value="location.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{ location.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Tags</span><span class="filter__value"></span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="tag in tags" @click="filterTagsCheckbox" :data-id="tag.id">
                                        <input type="checkbox" name="tag_id[]" :value="tag.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{ tag.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter--reset" @click="resetFilter">
                                <a href="javascript:;"> Reset Filter</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="section mt-3 no-bg">
                <data-table :ajax="employeesAjax" :columns="employeesColumns" :order="0" :serverSide="true"></data-table>
            </div>
        </div>
        <div class="content-area" v-if="!emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Employees</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/employees'" class="current">Employees</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section no-bg">
                <div class="empty-state mt-5">
                    <img :src="base_url + '/admin/img/noEmployees.svg'" />
                    <h5>No Employees</h5>
                    <p>
                        Looks like there are no users records <br />
                        Kindly Create one to show data.
                    </p>
                    <div class="d-flex">
                        <a href="#" class="btn btn-primary me-3" @click.prevent="createEmployee"> + Add New Employee</a>
                        <a href="#" class="btn btn-outline-secondary" @click.prevent="createEmployeeImport"> + Import Employee</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageEmployeeModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Create New Employee</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form-error :errors="errors"></form-error>
                    <form action="#" id="manageEmployeeForm" @submit.prevent="storeEmployee">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="">Upload User Image</label>
                                <input type="file" class="form-control" name="image" required />
                            </div>
                            <div class="form-group">
                                <label for="">External ID</label>
                                <input type="text" class="form-control" name="external_id" v-model="employeeForm.external_id" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.employeeForm.first_name.$error }">
                                <label for="">First Name</label>
                                <input type="text" class="form-control" name="first_name" v-model="employeeForm.first_name" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.employeeForm.last_name.$error }">
                                <label for="">Last Name</label>
                                <input type="text" class="form-control" name="last_name" v-model="employeeForm.last_name" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.employeeForm.email.$error }">
                                <label for="">Email ID</label>
                                <input type="email" class="form-control" name="email" v-model="employeeForm.email" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.employeeForm.phone.$error }">
                                <label for="">Phone Number</label>
                                <input type="text" class="form-control" name="phone" v-model="employeeForm.phone" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.employeeForm.designation.$error }">
                                <label for="">Designation</label>
                                <input type="text" class="form-control" name="designation" v-model="employeeForm.designation" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.employeeForm.department.$error }">
                                <label for="">Department</label>
                                <input type="text" class="form-control" name="department" v-model="employeeForm.department" />
                            </div>
                            <div class="form-group">
                                <label for="">Settings</label>
                                <div class="form-check">
                                    <input class="form-check-input" name="status" type="checkbox" v-model="employeeForm.status" value="1" id="status" />
                                    <label class="form-check-label" for="status"> Active </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" name="multi_location" type="checkbox" v-model="employeeForm.multi_location" value="1" id="multi_location" />
                                    <label class="form-check-label" for="multi_location"> Multi-Location Checkin / Checkout </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" name="block_attendance" type="checkbox" v-model="employeeForm.block_attendance" value="1" id="block_attendance" />
                                    <label class="form-check-label" for="block_attendance"> Block Attendance </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="">Allowed Attendance Types</label>
                                <div class="form-check" v-if="$root.packageInfo.static_qr">
                                    <input class="form-check-input" name="static_qr" v-model="employeeForm.static_qr" type="checkbox" value="1" id="static_qr" />
                                    <label class="form-check-label" for="static_qr"> QR</label>
                                </div>
                                <div class="form-check" v-if="$root.packageInfo.gps_checkin">
                                    <input class="form-check-input" name="gps_checkin" v-model="employeeForm.gps_checkin" type="checkbox" value="1" id="gps_checkin" />
                                    <label class="form-check-label" for="gps_checkin"> Remote </label>
                                </div>
                                <div class="form-check" v-if="$root.packageInfo.qr_card">
                                    <input class="form-check-input" name="qr_card" v-model="employeeForm.qr_card" type="checkbox" value="1" id="qr_card" />
                                    <label class="form-check-label" for="qr_card"> Kiosk </label>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageEmployeeModalImport" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Import Employees</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form action="#" id="importEmployeeForm" @submit.prevent="importEmployee" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="">Import Employees</label>
                                <input type="file" class="form-control" name="file" accept=".xls, .xlsx" required />
                            </div>
                            <div class="form-group">
                                <label for="">To download sample file, please click <a :href="base_url + '/admin/employee_import.xlsx'" download target="_blank">here</a></label>
                                <label for=""><span class="text-warning">Notes:</span>
                                    <ul>
                                        <li> In case of no location added for each employee in the sheet, default location will be assigned to employee.</li>
                                        <li> Following attendance types can be assigned (remote, kiosk and qr) for assigning multiple types for the same employee, add them as following: remote,kiosk .</li>
                                    </ul>
                                </label>
                            </div>

                             <div class="form-group" v-if="errors_import.length">
                               
                                <label for=""><span class="text-warning">Errors:</span>
                                    <ul v-for="errors in errors_import">
                                        <li v-for="error in errors">{{ error }}</li>
                                    </ul>
                                </label>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageTagsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Assign Tags</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="tags__listing">
                            <div class="tags__entry" v-for="tag in tags">
                                <h6>{{ tag.name }}</h6>
                                <div class="switch" :data-active="select_tag.includes(tag.id)" @click="switchTag(tag)">
                                    <input type="checkbox" :value="tag.id" />
                                    <div class="switch__wrapper">
                                        <div class="switch__toggle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-info" @click="saveTags">Assign</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    

</template>
<script>
import { required } from 'vuelidate/lib/validators'
import FormError from './FormError.vue';
export default {
    data() {
        return {
            showCreateEmployees: true,
            emptyState: false,
            editMode: false,
            employeesAjax: {},
            employeesColumns: [],
            subscription: {},
            tags: {},
            locations: [],
            bulk_update: [],
            check_all: false,
            select_tag:[],
            errors_import: [],
            employeeForm: new Form({
                external_id: '',
                first_name: '',
                last_name: '',
                designation: '',
                email: '',
                phone: '',
                department: '',
                static_qr: 0,
                gps_checkin: 0,
                qr_card: 0,
                multi_location: 0,
                block_attendance: 0,
                status: 1
            }),
            types: { static_qr: 0 },
            filterForm: new Form({
                search_data: "",
                status: [],
                locations: [],
                types: [],
                tags: []
            }),
            employeeFormImport: new Form({}),
            errors: false
        }
    },
    validations: {
        employeeForm: {
            first_name: {required}, last_name: {required}, 
            designation: {required}, email: {required}, phone: {required}, department: {required}
        }
    },
    created() {
        this.getAllEmployees();
        this.loadDefaultSubscriptionDetails();
        this.loadDataTableDetails();
        this.viewPage();
        this.deleteEmployee();
        this.getTags();
        this.getLocations();
    },
    methods: {
        loadDefaultSubscriptionDetails() {
            this.employeeForm.static_qr = this.subscription.static_qr;
            this.employeeForm.gps_checkin = this.subscription.gps_checkin;
            this.employeeForm.qr_card = this.subscription.qr_card;
        },
        getTags() {
            axios.get("/api/admin/tags").then(response => {
                this.tags = response.data.data;
                if (Object.keys(response.data.data).length > 0) {
                    this.emptyTags = false;
                } else {
                    this.emptyTags = true;
                }
            });
        },
        getLocations() {
            axios.get("/api/admin/locations").then(response => {
                this.locations = response.data.data.records;

                if (Object.keys(response.data.data.records).length > 0) {
                    this.emptyLocations = false;
                } else {
                    this.emptyLocations = true;
                }
            });
        },
        getAllEmployees() {
            axios.get("/api/admin/employees").then(response => {
                if (Object.keys(response.data.data.employees).length > 0) { // Check if there are employees or not
                    this.emptyState = true;
                } else {
                    this.emptyState = false;
                }
                this.subscription = response.data.data.subscription;
                this.showCreateEmployees = response.data.data.creating_employees_availability;
            });
        },
        loadDataTableDetails() {

            let vuejs = this;

            this.employeesAjax = {
                url: `/api/admin/employees/grid`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            let static_image_url = this.$root.base_url;

            this.employeesColumns = [{
                    name: '<input type="checkbox" value="all" class="check-all">',
                    data: null,
                    render(data, type, row, meta) {
                        let check = '';
                        var check_ids=Array.from(vuejs.bulk_update);
                      
                        var cehckData=data.id;
                        if(check_ids.includes(cehckData.toString())) {
                          
                            check = 'checked=""';
                        }else if(vuejs.check_all){
                         
                            check = 'checked=""';

                            vuejs.addCheckList(data.id, '1');
                             
                        }
                       
                        let html = `<input type="checkbox" `+check+` value="${data.id}" name="bulk_update" class="get-employee-id">`;
                        return html;
                    },
                    orderable: false
                },
                {
                    name: 'User Details',
                    data: null,
                    render(data, type, row, meta) {
                        let src = `${static_image_url}/admin/img/user-avatar.jpeg`;
                        if (data.image != '') {
                            src = data.full_image_path;
                        }
                        let html = `<a href='javascript:;' class="user-datatable__wrapper view-employee-details" data-id="${data.id}">
                                    <img class="user-datatable__img" src="${src}" />
                                    <div class="user-datatable__details">
                                        <h6>${data.full_name}</h6>
                                        <p>${data.designation}</p>
                                    </div>
                                </a>`;
                        return html;
                    },
                },
                { name: 'Email ID', data: 'employee.email', orderable: true, searchable: true },
                { name: 'Mobile No.', data: 'phone', orderable: true, searchable: true },
                { name: 'Department', data: 'department', orderable: true, searchable: true },
                { name: 'Status', data: 'status', orderable: true, searchable: true },
                {
                    name: 'Actions',
                    data: null,
                    render(data, type, row, meta) {
                        return `<div class="action-bar">
                                <a href="javascript:;" data-id="${data.id}" class="view-employee-details"><img src="/admin/img/view.svg" /></a>
                                <a href="javascript:;" data-id="${data.id}" class="delete-employee"><img src="/admin/img/delete.svg" /></a>
                            </div>`;
                    },
                },
            ];
        },
        refreshDataTable() {
            let locationsFilter = this.filterForm.locations.toString();
            let typesFilter = this.filterForm.types.toString();
            let statusFilter = this.filterForm.status.toString();
            let tagsFilter = this.filterForm.tags.toString();
            let filters = `search_data=${this.filterForm.search_data}&types=${typesFilter}&locations=${locationsFilter}&status=${statusFilter}&tags=${tagsFilter}`;

            this.employeesAjax = {
                url: `/api/admin/employees/grid?${filters}`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            let options = {
                ajax: this.employeesAjax,
                scrollY: false,
                scrollX: true,
                serverSide: true,
                searching: false,
                dom: '<"top">rt<"bottom"<"left-actions"li>p><"clear">',
                columnDefs: [],
                select: {
                    style: "os",
                    selector: "td:first-child",
                },
                order: [
                    [0, "desc"]
                ],
                columns: this.employeesColumns,
            };

            $(".user-datatable").DataTable().destroy();

            $(".user-datatable").DataTable(options).draw();
        },
        viewPage() {
            let router = this.$router;
            $(document).on("click", ".view-employee-details", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                let url = `/employees/${id}`;
                router.push(url).catch(() => {});
            });
            let vuejs = this;
            $(document).on("click", ".get-employee-id", function(e) {
                if ($(this).prop("checked") == true) {
                    vuejs.addCheckList($(this).val(), '1');
                } else if ($(this).prop("checked") == false) {
                    vuejs.addCheckList($(this).val(), '0');
                }
                $('.check-all').prop('checked', false);
                 vuejs.check_all = false;
            });

            $(document).on("click", ".check-all", function(e) {
                if ($(this).prop("checked") == true) {
                    vuejs.check_all = true;
                    $('.get-employee-id').prop('checked', true);
                    $("input:checkbox[name=bulk_update]:checked").each(function() {
                        vuejs.addCheckList($(this).val(), '1');
                    });

                } else {
                    vuejs.check_all = false;
                    $('.get-employee-id').prop('checked', false);
                    vuejs.bulk_update = [];
                }

            });
        },
        deleteEmployee() {
            let $this = this;
            $(document).on("click", ".delete-employee", function(e) {
                e.preventDefault();
                let employee_id = $(this).data("id");
                $.confirm({
                    title: 'Confirmation!',
                    content: 'Are you sure to delete this employee?',
                    buttons: {
                        confirm: {
                            btnClass: 'btn-red',
                            keys: ['enter'],
                            action: function() {
                                axios({
                                    method: "delete",
                                    url: `/api/admin/employees/${employee_id}`,
                                }).then((response) => {
                                    if(response.data.status) {
                                        Toast.fire({ icon: 'success', title: response.data.message });
                                    } else {
                                        $.alert(response.data.message);
                                    }
                                    $this.refreshDataTable();
                                }, (error) => {
                                    Toast.fire({ icon: 'error', title: "Oops, something went wrong." });
                                });
                            }
                        },
                        cancel: function() {
                            Toast.fire({ icon: 'success', title: "Cancelled." });
                        }
                    }
                });
            });
        },
        addCheckList(id, flag) {
           
            if (flag == 1) {
                this.bulk_update.push(id);
            } else {

                let i = this.bulk_update.map(item => item).indexOf(id) // find index of your object
                console.log(i);
                this.bulk_update.splice(i, 1);
            }
        },
        createEmployee() {
            this.employeeForm.clear();
            this.employeeForm.reset();
            this.loadDefaultSubscriptionDetails();
            $("#manageEmployeeModal").modal("show");
        },
        storeEmployee() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                if(!this.$v.required) {
                    $.alert("Please fill all requried fields.");
                }
            } else {
                let formData = new FormData($("#manageEmployeeForm")[0]);
                formData.append("token", localStorage.getItem("admin_auth"));
                axios({
                    method: "post",
                    url: "/api/admin/employees",
                    data: formData
                }).then((response) => {
                    if (response.data.status) {
                        $("#manageEmployeeModal").modal("hide");
                        Toast.fire({ icon: 'success', title: response.data.message });
                        this.refreshDataTable();
                        this.errors = false;
                    } else {
                        this.errors = response.data.message;

                    }
                }, (error) => {
                    console.log(error)
                });
            }
        },
        createEmployeeImport() {
            this.employeeFormImport.clear();
            this.employeeFormImport.reset();
            $("#manageEmployeeModalImport").modal("show");
        },
        importEmployee() {
            let formData = new FormData($("#importEmployeeForm")[0]);
            formData.append("token", localStorage.getItem("admin_auth"));
            axios({
                method: "post",
                url: "/api/admin/employees/import_employees",
                data: formData
            }).then((response) => {

                if (response.data.status) {
                    $("#manageEmployeeModalImport").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                    this.errors = false;
                    this.errors_import=[];
                } else {
                    
                    this.errors = response.data.message; 
                    this.errors_import=[];
                    
                }
            }, (error) => {

               if(error.response.status==422)
               {

                  this.errors_import = error.response.data.errors;

               }else{
                  console.log(error);
               }
            });
        },
        deleteBulk() {
            if (this.bulk_update.length == 0) {
                $.alert('Please select employees');
            } else {
                let $this = this;
                $.confirm({
                    title: 'Confirmation!',
                    content: 'You will not be able to recover these employees!',
                    buttons: {
                        confirm: {
                            btnClass: 'btn-red',
                            keys: ['enter'],
                            action: function() {
                                axios({
                                    method: "post",
                                    url: "/api/admin/employees/delete_employee",
                                    data: { ids: $this.bulk_update },
                                }).then((response) => {
                                    Toast.fire({ icon: 'success', title: response.data.message });
                                    $this.bulk_update = [];
                                    $this.refreshDataTable();
                                }, (error) => {
                                    console.log(error)
                                });
                            }
                        },
                        cancel: function() {
                            Toast.fire({ icon: 'success', title: "Cancelled." });
                        }
                    }
                });
            }

        },
        filterLocationsCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedLocations = this.filterForm.locations;
            this.filterForm.locations = this.setCheckedCheckboxes(currentTargetValues, checkedLocations);
            this.applyFilter();
        },
        filterTypesCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedTypes = this.filterForm.types;
            this.filterForm.types = this.setCheckedCheckboxes(currentTargetValues, checkedTypes);
            this.applyFilter();
        },
        filterStatusCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedStatus = this.filterForm.status;
            this.filterForm.status = this.setCheckedCheckboxes(currentTargetValues, checkedStatus);
            this.applyFilter();
        },
        filterTagsCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedTags = this.filterForm.tags;
            this.filterForm.tags = this.setCheckedCheckboxes(currentTargetValues, checkedTags);
            this.applyFilter();
        },
        setCheckedCheckboxes(currentTargetValues, checkedOptions) {
            if (currentTargetValues.getAttribute("data-active") && currentTargetValues.getAttribute("data-id")) {
                if (currentTargetValues.getAttribute("data-active") == "false") {
                    checkedOptions.push(currentTargetValues.getAttribute("data-id"));
                } else {
                    var index = checkedOptions.indexOf(currentTargetValues.getAttribute("data-id"));
                    if (index !== -1) {
                        checkedOptions.splice(index, 1);
                    }
                }
            }
            return checkedOptions;
        },
        applyFilter() {
            this.refreshDataTable();
        },
        resetFilter() {
            this.filterForm.clear();
            this.filterForm.reset();
            this.refreshDataTable();
        },
        getExport() {
            let params = this.prepareExportFilters();
            window.open("/api/admin/employees/export?" + $.param(params));
        },
        getQrCode() {
            let params = this.prepareExportFilters();
            window.open("/api/admin/employees/export_qr?" + $.param(params));
        },
        prepareExportFilters() {
            let locationsFilter = this.filterForm.locations.toString();
            let typesFilter = this.filterForm.types.toString();
            let statusFilter = this.filterForm.status.toString();
            let tagsFilter = this.filterForm.tags.toString();

            let params = [
                {"name": "search_data", "value": this.filterForm.search_data},
                {"name": "types", "value": typesFilter},
                {"name": "locations", "value": locationsFilter},
                {"name": "tags", "value": tagsFilter},
                {"name": "status", "value": statusFilter},
                {"name": "token", "value": localStorage.getItem("admin_auth")},
                {"name": "ids", "value": this.bulk_update}
            ];

            return params;
        },
        assignTags(){
            $("#manageTagsModal").modal("show");
        },
        switchTag(tag) {
          if(this.select_tag.includes(tag.id))
          {
                let i = this.select_tag.map(item => item).indexOf(tag.id) // find index of your object
                this.select_tag.splice(i, 1);
          }else{
            this.select_tag.push(tag.id);
          }
          
        },
        saveTags()
        {
            var formData = $("#getFilterDataform").serializeArray();
            var token = { "name": "token", "value": localStorage.getItem("admin_auth") };
            formData.push(token);
            if(this.check_all==true)
            {
              var ids = { "name": "ids", "value": [] };
            }else{
              var ids = { "name": "ids", "value": this.bulk_update };  
            }
            
            formData.push(ids);

            var tags = { "name": "tags", "value": this.select_tag };
            formData.push(tags);

            var check_all = { "name": "check_all", "value": this.check_all };
            formData.push(check_all);

            axios({
                method: "post",
                url: "/api/admin/employees/assign_tags",
                data: $.param(formData)
            }).then((response) => {
                if (response.data.status) {
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.select_tag=[];
                    $("#manageTagsModal").modal("hide");

                } else {
                    this.errors = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        }
    },
    components: {
        FormError
    }

}

</script>
